<template>
    <div>
      <h2>Users</h2>
      <ul>
        <li v-for="user in tenantServices" :key="user.id">{{ user.name }}</li>
      </ul>
    </div>
  </template>

  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'Users',
    computed: {
      ...mapState(['tenantServices']),
    },
  };
  </script>
